(function () {
  const YOUTUBE_FINAL_MS = 14000;
  const YOUTUBE_EARLY_MS = 4000;
  const VIDEO_FINAL_MS = 14000;

  function messageText() {
    const t = window.videoFunctionalCookieNoticeText;
    return typeof t === 'string' ? t.trim() : '';
  }

  function showFunctionalNotice(deferredMedia) {
    const msg = messageText();
    if (!msg || deferredMedia.dataset.functionalVideoOk === '1') return;
    const prev = deferredMedia.previousElementSibling;
    if (prev && prev.matches && prev.matches('p.video-section__cookie-notice')) return;
    const p = document.createElement('p');
    p.className = 'video-section__cookie-notice';
    p.textContent = msg;
    deferredMedia.parentNode.insertBefore(p, deferredMedia);
  }

  function hideFunctionalNotice(deferredMedia) {
    const prev = deferredMedia.previousElementSibling;
    if (prev && prev.matches && prev.matches('p.video-section__cookie-notice')) prev.remove();
  }

  function patchYoutubeParams(iframe) {
    try {
      const raw = iframe.getAttribute('src') || iframe.src || '';
      if (!raw.includes('youtube.com/embed') && !raw.includes('youtube-nocookie.com/embed')) return;
      const u = new URL(raw, window.location.href);
      u.searchParams.set('enablejsapi', '1');
      u.searchParams.set('origin', window.location.origin);
      const nu = u.toString();
      if (nu !== raw) iframe.src = nu;
    } catch (e) {}
  }

  function enqueueYouTubeIframeApi(done) {
    if (window.YT && window.YT.Player) {
      done();
      return;
    }
    const queue = window.__functionalNoticeYtQueue || (window.__functionalNoticeYtQueue = []);
    queue.push(done);
    if (window.__functionalNoticeYtLoading) return;
    window.__functionalNoticeYtLoading = true;
    const prev = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = function () {
      if (typeof prev === 'function') prev();
      const q = window.__functionalNoticeYtQueue || [];
      window.__functionalNoticeYtQueue = [];
      q.forEach(function (fn) {
        try {
          fn();
        } catch (err) {}
      });
    };
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    tag.async = true;
    document.head.appendChild(tag);
  }

  function enqueueVimeoPlayerApi(done) {
    if (window.Vimeo && window.Vimeo.Player) {
      done();
      return;
    }
    const queue = window.__functionalNoticeVimeoQueue || (window.__functionalNoticeVimeoQueue = []);
    queue.push(done);
    if (window.__functionalNoticeVimeoLoading) return;
    window.__functionalNoticeVimeoLoading = true;
    const tag = document.createElement('script');
    tag.src = 'https://player.vimeo.com/api/player.js';
    tag.async = true;
    tag.onload = function () {
      const q = window.__functionalNoticeVimeoQueue || [];
      window.__functionalNoticeVimeoQueue = [];
      q.forEach(function (fn) {
        try {
          fn();
        } catch (err) {}
      });
    };
    tag.onerror = function () {
      const q = window.__functionalNoticeVimeoQueue || [];
      window.__functionalNoticeVimeoQueue = [];
      q.forEach(function (fn) {
        try {
          fn();
        } catch (err) {}
      });
    };
    document.head.appendChild(tag);
  }

  function youtubeLooksPlayable(player) {
    try {
      const YPS = window.YT.PlayerState;
      const st = player.getPlayerState();
      if (st === YPS.PLAYING || st === YPS.BUFFERING) return true;
      const d = typeof player.getDuration === 'function' ? player.getDuration() : NaN;
      if (typeof d === 'number' && d > 0 && (st === YPS.PAUSED || st === YPS.CUED)) return true;
      return false;
    } catch (e) {
      return false;
    }
  }

  function observeYoutubeIframe(deferredMedia, iframe) {
    if (!messageText()) return;

    patchYoutubeParams(iframe);

    let settled = false;
    let failTimerId;
    let earlyTimerId;
    let bindStarted = false;
    const watchdogId = window.setTimeout(function () {
      if (!settled) settle(false);
    }, 22000);

    function settle(ok) {
      if (settled) return;
      settled = true;
      window.clearTimeout(watchdogId);
      window.clearTimeout(failTimerId);
      window.clearTimeout(earlyTimerId);
      if (ok) {
        deferredMedia.dataset.functionalVideoOk = '1';
        hideFunctionalNotice(deferredMedia);
      } else {
        showFunctionalNotice(deferredMedia);
      }
    }

    function bindPlayer() {
      if (bindStarted || settled) return;
      bindStarted = true;
      enqueueYouTubeIframeApi(() => {
        if (settled || !iframe.isConnected) return;
        try {
          new window.YT.Player(iframe, {
            events: {
              onReady: function (evt) {
                earlyTimerId = window.setTimeout(function () {
                  if (youtubeLooksPlayable(evt.target)) settle(true);
                }, YOUTUBE_EARLY_MS);
                failTimerId = window.setTimeout(function () {
                  if (!youtubeLooksPlayable(evt.target) && evt.target.getPlayerState() === window.YT.PlayerState.UNSTARTED) {
                    settle(false);
                  } else {
                    settle(true);
                  }
                }, YOUTUBE_FINAL_MS);
              },
              onStateChange: function (ev) {
                if (ev.data === window.YT.PlayerState.PLAYING || ev.data === window.YT.PlayerState.BUFFERING) {
                  settle(true);
                }
              },
              onError: function () {
                settle(false);
              },
            },
          });
        } catch (e) {
          settle(false);
        }
      });
    }

    iframe.addEventListener('load', bindPlayer, { once: true });
    window.setTimeout(function () {
      if (!settled) bindPlayer();
    }, 250);
  }

  function observeVimeoIframe(deferredMedia, iframe) {
    if (!messageText()) return;

    let settled = false;
    let finalTimerId;

    function settle(ok) {
      if (settled) return;
      settled = true;
      window.clearTimeout(finalTimerId);
      if (ok) {
        deferredMedia.dataset.functionalVideoOk = '1';
        hideFunctionalNotice(deferredMedia);
      } else {
        showFunctionalNotice(deferredMedia);
      }
    }

    enqueueVimeoPlayerApi(() => {
      if (settled || !iframe.isConnected) return;
      try {
        const player = new window.Vimeo.Player(iframe);

        player.on('play', function () {
          settle(true);
        });
        player.on('bufferstart', function () {
          settle(true);
        });
        player.on('error', function () {
          settle(false);
        });

        finalTimerId = window.setTimeout(function () {
          Promise.all([player.getDuration().catch(() => 0), player.getPaused().catch(() => null)])
            .then(function ([duration]) {
              if (duration && duration > 0) settle(true);
              else settle(false);
            })
            .catch(function () {
              settle(false);
            });
        }, YOUTUBE_FINAL_MS);
      } catch (e) {
        settle(false);
      }
    });
  }

  function observeHtmlVideo(deferredMedia, video) {
    if (!messageText()) return;

    let settled = false;
    let finalTimerId;

    function settle(ok) {
      if (settled) return;
      settled = true;
      window.clearTimeout(finalTimerId);
      if (ok) {
        deferredMedia.dataset.functionalVideoOk = '1';
        hideFunctionalNotice(deferredMedia);
      } else {
        showFunctionalNotice(deferredMedia);
      }
    }

    finalTimerId = window.setTimeout(function () {
      if (video.error || (video.readyState < 2 && video.networkState === video.NETWORK_NO_SOURCE))
        settle(false);
      else settle(true);
    }, VIDEO_FINAL_MS);

    video.addEventListener(
      'playing',
      function () {
        settle(true);
      },
      { once: true }
    );
    video.addEventListener(
      'error',
      function () {
        settle(false);
      },
      { once: true }
    );
  }

  window.initDeferredMediaFunctionalNotice = function (deferredMedia, mediaEl) {
    if (!messageText() || !deferredMedia || !mediaEl) return;
    if (deferredMedia.dataset.functionalNoticeInit === '1') return;
    deferredMedia.dataset.functionalNoticeInit = '1';

    const type = mediaEl.tagName;
    if (type === 'IFRAME') {
      if (mediaEl.classList.contains('js-youtube')) observeYoutubeIframe(deferredMedia, mediaEl);
      else if (mediaEl.classList.contains('js-vimeo')) observeVimeoIframe(deferredMedia, mediaEl);
      return;
    }
    if (type === 'VIDEO') observeHtmlVideo(deferredMedia, mediaEl);
  };

  function scanDeferredMedia() {
    if (!messageText()) return;
    document.querySelectorAll('deferred-media[loaded]').forEach(function (dm) {
      const media = dm.querySelector('iframe.js-youtube, iframe.js-vimeo, video');
      if (!media || dm.dataset.functionalNoticeInit === '1') return;
      window.initDeferredMediaFunctionalNotice(dm, media);
    });
  }

  function trustArcVideoIframeBlocked(iframe) {
    if (!iframe || iframe.tagName !== 'IFRAME') return false;
    if (iframe.getAttribute('data-ta-blocked') === '1') return true;
    const src = (iframe.getAttribute('src') || '').trim();
    const taSrc = iframe.getAttribute('data-ta-src');
    if (taSrc && (!src || src === 'about:blank')) return true;
    return false;
  }

  function shouldShowTrustArcVideoNotice(iframe) {
    return trustArcVideoIframeBlocked(iframe);
  }

  function showVideoContainerNotice(container) {
    const msg = messageText();
    if (!msg) return;
    if (container.querySelector(':scope > p.video-section__cookie-notice')) return;
    const iframe = container.querySelector('iframe');
    if (!iframe) return;
    const p = document.createElement('p');
    p.className = 'video-section__cookie-notice';
    p.textContent = msg;
    container.insertBefore(p, container.firstChild);
  }

  function hideVideoContainerNotice(container) {
    const n = container.querySelector(':scope > p.video-section__cookie-notice');
    if (n) n.remove();
  }

  function scanTrustArcVideoContainers() {
    if (!messageText()) return;
    document.querySelectorAll('.video-container').forEach(function (container) {
      const iframe = container.querySelector('iframe');
      if (!iframe) {
        hideVideoContainerNotice(container);
        return;
      }
      if (!iframe.getAttribute('data-ta-src') && !iframe.getAttribute('data-ta-blocked')) {
        if (!trustArcVideoIframeBlocked(iframe)) hideVideoContainerNotice(container);
        return;
      }
      if (shouldShowTrustArcVideoNotice(iframe)) showVideoContainerNotice(container);
      else hideVideoContainerNotice(container);
    });
  }

  function runAllScans() {
    scanDeferredMedia();
    scanTrustArcVideoContainers();
  }

  const mo = new MutationObserver(runAllScans);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      runAllScans();
      mo.observe(document.documentElement, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['loaded', 'src', 'data-ta-blocked', 'data-ta-src'],
      });
    });
  } else {
    runAllScans();
    mo.observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['loaded', 'src', 'data-ta-blocked', 'data-ta-src'],
    });
  }

  let trustArcPollTicks = 0;
  const trustArcPollTimer = window.setInterval(function () {
    trustArcPollTicks++;
    scanTrustArcVideoContainers();
    if (trustArcPollTicks >= 120) window.clearInterval(trustArcPollTimer);
  }, 500);
})();
